<template>
  <div>
    <v-card class="px-6">
      <v-layout row wrap>
        <v-flex sm6 xs12>
          <v-text-field
            class="mx-4"
            label="Description"
            v-model="name"
          ></v-text-field>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field
            class="mx-4"
            label="Amount"
            v-model="amount"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex sm6 xs12>
          <v-btn
            dark
            small
            class="mx-4 mb-4"
            rounded
            :color="getThemeColor"
            @click="createSalary()"
            ><v-icon>mdi-plus</v-icon>Create Salary</v-btn
          >
        </v-flex>
      </v-layout></v-card
    >
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    amount: 0,
    name: "Basic Salary",
  }),
  methods: {
    createSalary() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-salary",
          { amount: this.amount, name: this.name },
          this.getAccessToken
        )
        .then((salary) => {
          this.$emit("salary-created", salary);
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>

<style></style>
